module.exports = __webpack_public_path__ + "img/ic_tripadvisor-2.5.3e2a2e39.svg";